module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    class: [{
      'weui-loadmore_line': _vm.line,
      'weui-loadmore_line weui-loadmore_dot': !_vm.text
    }, 'weui-loadmore']
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.icon),
      expression: "icon"
    }],
    staticClass: "weui-loading"
  }), _vm._v(" "), _c('span', {
    staticClass: "weui-loadmore__tips"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6849d63c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/cut_off/cut-off.vue
// module id = 256
// module chunks = 0